export default "__VITE_ASSET__BPK6P65F__"